module.exports = __webpack_public_path__ + "static/media/box-ballot.da590d92.svg";